import React from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";

const Header = ({ onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout(); // Call logout function from App.js
    navigate("/"); // Redirect to GoogleLogin
  };

  return (
    <header className="header">
  <div style={{ display: "flex", alignItems: "center" }}>
    <img src="Haqdarshak_logo.png" alt="Haqdarshak Logo" className="logo" />
    <h2>Haqdarshak Dashboards</h2>
  </div>
  <button className="logout-button" onClick={handleLogout}>Logout</button>
</header>

  );
};

export default Header;
